import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../services/auth.service";
import {RootShareService} from "../../../../services/root.shared.service";
import {PatientGeneralHistory} from "../../../../models/forms/referral/patient.general.history";
import {ReferralPresentingSymptom} from "../../../../models/forms/referral/referral.presenting.symptom";

@Component({
    selector: 'referral-presenting-symptom-component',
    templateUrl: './referral.presenting.symptom.html'
})
export class ReferralPresentingSymptomComponent {
    @Input() referralPresentingSymptom: ReferralPresentingSymptom;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }
}
